import emiter, { _EVENTS } from '../../../events';
import { _APIS } from 'apis';
import request from 'request';
import { Modal, message } from 'antd';
import moment from 'moment';
import { formatTimeRange } from '../../../utils/tool';
import { DEFAULT_PAGE_INFO } from '../../../consts';
import React, { useEffect, useState } from 'react';
import { copyTextToClipboard } from 'utils/copyTextToClipboard';

export const useOrderList = () => {
	// 拿到查询当前的详情
	const [details, setDetails] = useState();
	const searchFormReset = (form: any) => {
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.SEARCH, {
			...DEFAULT_PAGE_INFO,
			...form.getFieldsValue(),
		});
	};
	const searchFormFinish = (form: any) => {
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.SEARCH, {
			...DEFAULT_PAGE_INFO,
			...form.getFieldsValue(),
		});
	};

	const onSearchAction = (load: any) => {
		emiter.on(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.SEARCH, load);
	};

	const search = (params: any) => request.post(_APIS.ORDER_MANAGEMENT.ORDER_LIST.SEARCH, params);

	const updateRenewal = (params: any) => request.post(_APIS.ORDER_MANAGEMENT.ORDER_LIST.UPDATE_RENEWAL, params);

	// 排车
	const updateArrangeCar = (params: any) => request.post(_APIS.ORDER_MANAGEMENT.ORDER_LIST.ARRANGE_CAR, params);

	// 排司机
	const updateArrangeDriver = (params: any) => request.post(_APIS.ORDER_MANAGEMENT.ORDER_LIST.ARRANGE_DRIVER, params);

	// 免费续租
	const updateFreeRenewal = (params: any) => request.post(_APIS.ORDER_MANAGEMENT.ORDER_LIST.FREE_RENEWAL, params);

	// 续租详情
	const renewalDetail = (params: any) => request.get(_APIS.ORDER_MANAGEMENT.ORDER_LIST.RENEWAL_DETAIL, { params });

	// 续租同意
	const renewalAgree = (params: any) => request.post(_APIS.ORDER_MANAGEMENT.ORDER_LIST.RENEWAL_AGREE, params);

	//  续租拒绝
	const renewalReject = (params: any) => request.post(_APIS.ORDER_MANAGEMENT.ORDER_LIST.RENEWAL_REJECT, params);

	// 添加备注
	const updateRemark = (params: any) => request.post(_APIS.ORDER_MANAGEMENT.ORDER_LIST.REMARK, params);

	// 押金扣款
	const updateOrderDeduct = (params: any) => request.post(_APIS.ORDER_MANAGEMENT.ORDER_LIST.DEDUCT, params);

	// 订单退款
	const submitOrderRefund = (params: any) => request.post(_APIS.ORDER_MANAGEMENT.ORDER_LIST.ORDER_REFUND, params);

	// 押金扣款后退款
	const updateDeductRefund = (params: any) => request.post(_APIS.ORDER_MANAGEMENT.ORDER_LIST.DEDUCT_REFUND, params);

	// 押金解冻
	const updateUnfreeze = (params: any) => request.post(_APIS.ORDER_MANAGEMENT.ORDER_LIST.UNFREEZING, params);
	// 获取车型详情
	const getCarModelDetail = (params: any) => request.get(_APIS.ORDER_MANAGEMENT.ORDER_LIST.GET_CAR_MODEL_DETAIL, { params });

	const getDetail = (params: any) => request.get(_APIS.ORDER_MANAGEMENT.ORDER_LIST.DETAIL, { params });

	const getSaasApolloConfig = (params: any) => request.get(_APIS.PRODUCT_PRICE.COMMON.CONFIG, { params });

	// const pickupCarReq = (params: any) => request.post('/rental/scm/order/veh/pickup', params);
	// const returnCarReq = (params: any) => request.post('/rental/scm/order/veh/return', params);

	const pickupCarReq = (params: any) => request.post('/rental/scm/order/pickup/save', params);
	const returnCarReq = (params: any) => request.post('/rental/scm/order/veh/return', params);

	const pickupSuccess = (params: any) => request.post(_APIS.ORDER_MANAGEMENT.ORDER_LIST.PICKUP_SUCCESS, params);

	const sendLink = (params: any) => request.post(_APIS.ORDER_MANAGEMENT.ORDER_LIST.SEND_LINK, params);

	const sendContract = (params: any) => request.post(_APIS.ORDER_MANAGEMENT.ORDER_LIST.SEND_CONTRACT, params);

	const getContractStatusReq = (params: any) => request.post(_APIS.ORDER_MANAGEMENT.ORDER_LIST.CONTRACT_STATUS, params);

	// 押金扣款后撤销
	const deductRevert = (params: any) => request.post(_APIS.ORDER_MANAGEMENT.ORDER_LIST.DEDUCT_REVERT, params);

	const tablePagination = (data: any) => {
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.SEARCH, data);
	};

	const tableActionView = async (data: any) => {
		const res = await getDrawerDetail(data);
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.VIEW, {
			detail: res,
			drawerInfo: {
				disabled: true,
				title: '查看',
			},
		});
	};
	const orderDetailRefresh = async (data: any) => {
		const res = await getDrawerDetail(data);
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.REFRESH, {
			detail: res,
			drawerInfo: {
				disabled: true,
				title: '查看',
			},
		});
	};

	const tableActionArrangeCar = async (data: any) => {
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.ARRANGE_CAR, data);
	};

	const tableActionArrangeDriver = async (data: any) => {
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.ARRANGE_DRIVER, data);
	};

	// 取车
	const tableActionPickupCar = async (data: any) => {
		const res = await getDrawerDetail(data);
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.VIEW, {
			detail: res,
			drawerInfo: {
				disabled: false,
				title: '查看',
			},
		});
	};

	// 还车
	const tableActionReturnCar = async (data: any) => {
		const res = await getDrawerDetail(data);
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.VIEW, {
			detail: res,
			drawerInfo: {
				disabled: false,
				title: '查看',
			},
		});
	};

	const tableActionAgreeRenew = async (data: any) => {
		const res = await renewalDetail({
			renewal_order_code: data?.renewal_order?.renewal_order_code,
		});
		const resData = res.data;
		if (resData) {
			if (res?.data?.occupy_order_num > 0) {
				Modal.confirm({
					title: '操作提示',
					okText: '确认',
        			cancelText: '取消',
					cancelButtonProps: {
						style: {
							display: 'none',
						},
					},
					content: `该订单（订单号：${data.order_code}，续租时间：${formatTimeRange(
						resData.renewal_pickup_time,
						resData.renewal_return_time
					)}）所续租的车辆在续租时间内已被${res?.data?.occupy_order_num}个订单占库，清将占库订单改排后再操作续租同意`,
					async onOk() {},
					okCancel: false,
				});
			} else {
				Modal.confirm({
					title: '操作提示',
					okText: '确认',
        			cancelText: '取消',
					content: `确认同意该订单的续租吗？确认后将延长车辆还车时间（订单号：${
						data.order_code
					}, 续租时间：${formatTimeRange(resData.renewal_pickup_time, resData.renewal_return_time)}）`,
					async onOk() {
						await renewalAgree({
							renewal_order_code: data?.renewal_order?.renewal_order_code,
						});
						message.success('操作成功');
						emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.SEARCH, {});
					},
				});
			}
		}
	};
	const tableActionRefuseRenew = async (data: any) => {
		const { order_code, renewal_order } = data;
		Modal.confirm({
			title: '操作提示',
			okText: '确认',
        	cancelText: '取消',
			content: `确认拒绝该订单（订单号：${order_code}，续租时间：${renewal_order.renewal_pickup_time} - ${renewal_order.renewal_return_time} ${renewal_order.tenancy}）的续租子订单吗？确认后将取消续租单并退款至用户。`,
			async onOk() {
				await renewalReject({ renewal_order_code: renewal_order.renewal_order_code });
				message.success('操作成功');
				emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.SEARCH, {});
			},
		});
		// emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.REFUSE_RENEW);
	};
	const tableActionFreeRenew = async (data: any) => {
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.FEE_RENEW, data || {});
	};

	// 免费续租
	const freeRenewSubmit = async (data: any, echoData: any) => {
		const params = {
			...data,
			return_time: moment(data.return_time).format('YYYY-MM-DD HH:mm:ss'),
		};
		await updateFreeRenewal({ ...params, order_code: echoData.order_code });
		message.success('操作成功');
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.SEARCH, {});
	};

	const getDrawerDetail = async (data: any) => {
		if (data.order_code || data?.order_info?.order_code) {
			const res = await getDetail({
				order_code: data.order_code || data?.order_info?.order_code,
			});
			setDetails(res.data);
			return res.data;
		}
	};

	const drawerSubmit = async (data: any, echoData: any) => {
		await updateRenewal({ ...data, rule_code: echoData.rule_code });
		message.success('操作成功');
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.SEARCH, {});
	};

	const prodBatchEditFn = async (data: any) => {};

	const arrangeCarModalOpen = (data: any) => {
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.ARRANGE_CAR, data);
	};

	// 排车
	const arrangeCarSubmit = async (data: any, echoData: any) => {
		await updateArrangeCar({ ...data, order_code: echoData.order_code });
		message.success('操作成功');
		orderDetailRefresh(echoData);
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.SEARCH, {});
	};

	const arrangeDriverModalOpen = (data: any) => {
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.ARRANGE_DRIVER, data);
	};

	// 排司机
	const arrangeDriverSubmit = async (data: any, echoData: any) => {
		await updateArrangeDriver({ ...data, order_code: echoData.order_code });
		message.success('操作成功');
		orderDetailRefresh(echoData);
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.SEARCH, {});
	};

	const remarkModalOpen = (data: any) => {
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.ORDER_REMARK, data);
	};

	// 订单备注
	const remarkCarSubmit = async (data: any, echoData: any) => {
		await updateRemark({ ...data, order_code: echoData.order_code });
		message.success('操作成功');
		orderDetailRefresh(echoData);
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.SEARCH, {});
	};

	const refundModalOpen = async (data: any) => {
		const res = await getDrawerDetail(data);
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.REFUND, res);
	};

	// 订单退款
	const orderRefundSubmit = async (data: any, echoData: any) => {
		await submitOrderRefund({
			...data,
			evidence: data?.evidence ? JSON.stringify(data?.evidence?.map((item: any) => item.file_addr)) : '',
			amount: parseInt(data.amount * 100 as any),
			order_code: echoData?.order_info?.order_code,
		});
		message.success('操作成功');
		orderDetailRefresh(echoData);
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.SEARCH, {});
	};

	const depositRefundOpen = async (data: any) => {
		const res = await getDrawerDetail(data);
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.REFUND, res);
	};

	// 押金扣款退款
	const depositRefundSubmit = async (data: any, echoData: any) => {
		await updateDeductRefund({
			...data,
			amount: parseInt(data.amount * 100 as any),
			evidence: data?.evidence ? JSON.stringify(data?.evidence?.map((item: any) => item.file_addr)) : '',
			deduct_no: echoData.deduct_no,
			order_code: echoData?.order_code,
		});
		message.success('操作成功');
		orderDetailRefresh(echoData);
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.SEARCH, {});
	};

	const deductionModalOpen = async (data: any) => {
		const res = await getDrawerDetail(data);
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.DEDUCTION, res);
	};

	// 押金扣款 (已调)
	const depositDeductionSubmit = async (data: any, echoData: any) => {
		await updateOrderDeduct({
			...data,
			evidence: data?.evidence ? JSON.stringify(data?.evidence?.map((item: any) => item.file_addr)) : '',
			amount: parseInt(data.amount * 100 as any),
			order_code: echoData?.order_info?.order_code,
		});
		message.success('操作成功');
		orderDetailRefresh(echoData);
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.SEARCH, {});
	};

	const unfreezingDepositModalOpen = async (data: any) => {
		const res = await getDrawerDetail(data);
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.UNFREEZING_DEPOSIT, res);
	};

	// 押金解冻

	const unfreezingDepositCarSubmit = async (data: any, echoData: any) => {
		const submitData = {...data}
		submitData.amount = parseInt(submitData.amount * 100 as any)
		await updateUnfreeze({ ...submitData, order_code: echoData?.order_info?.order_code });
		message.success('操作成功');
		orderDetailRefresh(echoData);
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.SEARCH, {});
	};

	const sendLinkSubmit = (data: any) => {
		sendLink({ order_code: data?.order_code }).then((res: any) => {
			copyTextToClipboard(res?.data?.sign_link, '链接复制成功，请发送给用户');
			orderDetailRefresh(data);
			emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.SEARCH, {});
		});
	}

	const sendContractSubmit = (data: any) => {
		sendContract({ order_code: data?.order_code }).then(() => {
			message.success('短信合同发送成功');
			orderDetailRefresh(data);
			emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.SEARCH, {});
		});
	}


	const pickupSuccessSubmit = (data: any) => {
		pickupSuccess({ order_code: data?.order_code }).then(() => {
			message.success('取车成功');
			orderDetailRefresh(data);
			emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.SEARCH, {});
		});
	}

	// 押金扣款后撤销
	const deductRevertSubmit = async (data: any) => {
		await deductRevert(data);
		message.success('操作成功');
		orderDetailRefresh(data);
		emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.SEARCH, {});
	};

	const pickupCar = (data: any, echoData: any) => {
		return pickupCarReq({
			order_code: echoData?.order_code,
			...data,
			// customer: {
			// 	idcard_front_image: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	idcard_back_image: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	driver_license_homepage: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	driver_license_subpage: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// },
			// vehicle: {
			// 	odometer_image: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	veh_inspection_video: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	front: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	left_front: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	left_rear: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	rear: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	right_rear: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	right_front: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	center_console: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	driver_pilot: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	rear_seats: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// },
			// contract_image: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// veh_damage: [
			// 	{
			// 		position: 1,
			// 		type: 1,
			// 		image: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	},
			// ],
		}).then(() => {
			orderDetailRefresh(echoData);
			emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.SEARCH, {});
		});
	};

	const returnCar = (data: any, echoData: any) => {
		return returnCarReq({
			order_code: echoData?.order_code,
			...data,
			// odometer_image: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// veh_inspection_video: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// customer: {
			// 	idcard_front_image: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	idcard_back_image: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	driver_license_homepage: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	driver_license_subpage: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// },
			// vehicle: {
			// 	odometer_image: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	veh_inspection_video: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	front: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	left_front: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	left_rear: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	rear: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	right_rear: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	right_front: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	center_console: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	driver_pilot: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	rear_seats: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// },
			// contract_image: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// outer_damage: [
			// 	{
			// 		position: 1,
			// 		type: 1,
			// 		image: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	},
			// ],
			// interior_damage: [
			// 	{
			// 		position: 1,
			// 		type: 1,
			// 		image: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// 	},
			// ],
			// veh_inspection: '/rental-saas-public/osim/common/171826985648654l37-202406131710',
			// refund: 100,
		}).then(() => {
			orderDetailRefresh(echoData);
			emiter.emit(_EVENTS.ORDER_MANAGEMENT.ORDER_LIST.SEARCH, {});
		});
	};

	return {
		searchFormReset,
		searchFormFinish,
		search,
		getDetail,
		updateRenewal,
		onSearchAction,
		tablePagination,
		tableActionView,
		tableActionArrangeCar,
		tableActionArrangeDriver,
		tableActionPickupCar,
		tableActionReturnCar,
		tableActionAgreeRenew,
		tableActionRefuseRenew,
		tableActionFreeRenew,
		freeRenewSubmit,
		getDrawerDetail,
		drawerSubmit,
		getSaasApolloConfig,
		prodBatchEditFn,
		arrangeCarModalOpen,
		arrangeCarSubmit,
		arrangeDriverModalOpen,
		arrangeDriverSubmit,
		remarkModalOpen,
		remarkCarSubmit,
		orderDetailRefresh,
		deductionModalOpen,
		depositDeductionSubmit,
		refundModalOpen,
		orderRefundSubmit,
		unfreezingDepositModalOpen,
		unfreezingDepositCarSubmit,
		depositRefundOpen,
		depositRefundSubmit,
		pickupCar,
		returnCar,
		deductRevertSubmit,
		getCarModelDetail,
		details,
		setDetails,
		pickupSuccess,
		sendLinkSubmit,
		sendContractSubmit,
		pickupSuccessSubmit,
		getContractStatusReq
	};
};
